<onyx-splash-screen></onyx-splash-screen>
<router-outlet />
